import * as PropTypes from "prop-types"
import React, {Component} from "react"
import {Button, Input, Popup} from "semantic-ui-react"

import shop from "shop/shop"


const showWarningToast = msg => {
	shop.toast( msg, "warning", false, "bottom" )
}


class ProductCount extends Component {

	render() {
		let {product, onChange} = this.props
		let showVEWarning = shop.config.checkout.limitToStock && (product.count >= Math.floor( product.stock / product.unit_multi ))

		return (
			<Input
				onChange={( e ) => {
					if (e.target.value === '') {
						product.count = 0;
						return;
					}
					const count = Math.round( e.target.value)

					if ( product.onChange ) {
						let ok = product.onChange( product )
						if ( !ok ) {
							showWarningToast( "Maximale Abnahmemenge erreicht" )
							return false
						}
					}
					product.count = Number( count )
					onChange( {product, count: count} )
				}}
				className="text-center"
				type="number"
				placeholder="0"
				action>
				<input value={product.count } tabIndex={99} style={{minWidth: "60px", maxWidth: "70px"}} />
				<Button
					size="tiny"
					icon="minus"
					onClick={() => {
						if ( shop.config.checkout.limitToStock ) product.count = Math.min( product.count, Math.floor( product.stock / product.unit_multi ) )
						if ( product.onChange ) {
							let ok = product.onChange( {count: product.count - 1} )
							if ( !ok ) {
								showWarningToast( "Maximale Abnahmemenge erreicht" )
								return false
							}
						}
						product.count = Math.max( product.count - 1, 0 )
						onChange( {product} )
					}} />
				<Button
					size="tiny"
					icon="plus"
					onClick={() => {
						if ( shop.config.checkout.limitToStock ) product.count = Math.min( product.count, Math.floor( product.stock / product.unit_multi ) )
						if ( product.onChange ) {
							let ok = product.onChange( {count: product.count + 1} )
							if ( !ok ) {
								showWarningToast( "Maximale Abnahmemenge erreicht" )
								return false
							}
						}
						product.count += 1
						onChange( {product} )
					}} />
				{showVEWarning &&
				<Popup trigger={<Button circular icon="warning" color="yellow" title="Keine weiteren Artikel auf Lager" />}
					   content="Keine weiteren Artikel auf Lager" />}
			</Input>)
	}
}

ProductCount.propTypes = {
	product : PropTypes.any,
	onChange: PropTypes.any
}


export default ProductCount



// WEBPACK FOOTER //
// ./src/theme/oehme/components/Product/ProductCount.js